'use client';
// 新聞頁置底廣告

import { useState, useEffect } from 'react';
import promoClient from '@/common/apiClient/promoClient';
import { PROMO_BANNER_POSITION_CODE } from '@/common/constant';
import Image from 'next/image';

const AdM102 = () => {
    const [banner, setBanner] = useState(null); // 廣告
    const storageKey = 'newsAd';

    // 取得廣告
    const getAdM102 = async () => {
        try {
            const result = await promoClient.getPromoBanner(
                PROMO_BANNER_POSITION_CODE.NEWS_BOTTOM_FIXED
            );

            if (result?.status === 'success') setBanner(result?.banners?.[0]);
        } catch (error) {
            console.error('Failed to fetch banner ad:', error);
        }
    };

    // 處理關閉廣告
    const onClose = () => {
        setBanner(null);
        localStorage.setItem(storageKey, Date.now().toString());
    };

    // 依時間判斷要不要取得廣告
    const handleFetchAd = () => {
        const adClosedAt = localStorage.getItem(storageKey); // 關閉的時間
        if (adClosedAt) {
            const timeElapsed = Date.now() - parseInt(adClosedAt, 10);

            // 計算 10 分鐘 （毫秒）
            if (timeElapsed > 10 * 60 * 1000) getAdM102();

            return;
        }

        getAdM102();
    };

    useEffect(() => {
        handleFetchAd();
    }, []);

    if (!banner) return null;

    return (
        <div className="hidden ulg:block fixed bottom-[64px] left-0 w-screen z-[3] px-[10px]">
            <div className="relative text-right">
                {/* 關閉按鈕 */}
                <button
                    onClick={onClose}
                    className="w-[25px] h-[25px] flex justify-end items-end mb-[5px] float-right dark:brightness-[3]"
                >
                    <Image
                        width={18}
                        height={18}
                        src="/images/icon/icon_close_button.svg"
                        alt="close_button"
                    />
                </button>

                <a href={banner?.link} target="_blank" rel="noreferrer noopener">
                    {banner?.image?.includes('.mp4') ? (
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="w-full max-h-[100px] min-h-[78px] rounded-[2px] object-cover"
                        >
                            <source src={banner?.image} />
                        </video>
                    ) : (
                        <Image
                            className="w-full max-h-[100px] min-h-[78px] object-cover object-center rounded-[2px]"
                            width={400}
                            height={78}
                            src={banner?.image}
                            alt="banner"
                        />
                    )}
                </a>
            </div>
        </div>
    );
};

export default AdM102;
